import { fetchFromApi } from './apiUtils';

const basePath = '/v1/user';

const getUserInstitutions = () => fetchFromApi(`${basePath}/institutions`);

export default {
  getUserInstitutions,
};
